var render = function render(){var _vm=this,_c=_vm._self._c;return _c('y-layout-body-menu',{attrs:{"aside-width":"9rem","menu":[
  {title:'空码管理',path:'/card/plugin/cdkey/empty'},
  {title:'用户管理',path: '/card/plugin/cdkey/user'},
  {title:'全部激活码',path: '/card/plugin/cdkey/list'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }